import EditTemplate from "../_templates/EditTemplate";
import { stadiumSchema } from "../../../schemas/stadium.schema";
import { getStadium, updateStadium } from "../../../api/coredata.api";

export default function EditStadium() {
  return (
    <EditTemplate
      title="Edit Stadium"
      schema={stadiumSchema}
      fetchFn={getStadium}
      updateFn={updateStadium}
      redirectPath="/cricket/stadiums"
    />
  );
}
